import { type OperationOut, operationsApi, refKeys } from '@/features/references/api'
import { typedSuspenseOptions } from '@/lib/query/typed-suspense-query'

export const operationsListQuery = () =>
  typedSuspenseOptions<readonly OperationOut[]>({
    queryKey: refKeys.operations(),
    queryFn: ({ signal }) => operationsApi.list(signal),
    staleTime: 30_000,
  })
